export default __webpack_public_path__ + "static/kynnet1-edde19af10bb3cddba19cfaaf79efa1f.jpeg";